import * as React from 'react';
import { Dropdown, DropdownProps, Form, Input, SemanticWIDTHS } from 'semantic-ui-react';

import Pasaporte from './componentes/Pasaporte';
import Rut from './componentes/Rut';

import * as rutUtils from 'src/modulos/Matriculas/IngresoNuevaMatricula/utils/rut';

export interface RutDatos {
    tipo: 'rut';
    rut: string;
}

const rutInicial: RutDatos = {
    tipo: 'rut',
    rut: '',
};

interface PasaporteDatos {
    tipo: 'pasaporte';
    pais: string;
    pasaporte: string;
}

const pasaporteInicial: PasaporteDatos = {
    tipo: 'pasaporte',
    pais: 'pe',
    pasaporte: '',
};

export type RutPasaporteDatos = RutDatos | PasaporteDatos;

export const rutPasaporteInicial: RutPasaporteDatos = {
    ...rutInicial,
};

export interface RutPasaporteInputProps {
    /** Valor que usará el campo. Requerido. */
    rutPasaporte: RutPasaporteDatos;

    /** Determina si el campo es requerido. Por defecto false. */
    requerido?: boolean;

    /** Muestra un mensaje de error, indicando que el rut no es válido. Por defecto false */
    error?: boolean;

    /** Función que será llamada cuando ocurra un cambio en el componente. Requerido. */
    alCambiar(rutPasaporte: RutPasaporteDatos): void;
}

export class RutPasaporteInput extends React.PureComponent<RutPasaporteInputProps> {
    private readonly rutPasaporteOptions = [
        { value: 'rut', text: 'Rut' },
        { value: 'pasaporte', text: 'Pasaporte' },
    ];

    private readonly cambioTipoDropdownStyle = { minWidth: '6em', paddingTop: '9px' };

    public render() {
        const { rutPasaporte, requerido = false, error = false } = this.props;

        return (
            <Input>
                <Dropdown
                    options={this.rutPasaporteOptions}
                    value={rutPasaporte.tipo}
                    onChange={this.manejarCambioTipo}
                    inline
                    style={this.cambioTipoDropdownStyle}
                />

                {rutPasaporte.tipo === 'rut' ? (
                    <Rut
                        rut={rutPasaporte.rut}
                        alCambiarRut={this.manejarCambioRut}
                        requerido={requerido}
                        error={error}
                    />
                ) : (
                    <Pasaporte
                        pais={rutPasaporte.pais}
                        pasaporte={rutPasaporte.pasaporte}
                        alCambiarPais={this.manejarCambioPais}
                        alCambiarPasaporte={this.manejarCambioPasaporte}
                        requerido={requerido}
                    />
                )}
            </Input>
        );
    }

    private readonly manejarCambioTipo = (_e: {}, { value }: DropdownProps) => {
        if (value === 'rut') {
            this.realizarCambio({ ...(rutInicial as RutPasaporteDatos) });
        } else {
            this.realizarCambio({ ...(pasaporteInicial as RutPasaporteDatos) });
        }
    };

    private readonly manejarCambioRut = (rut: string) => {
        this.realizarCambio({
            ...(this.props.rutPasaporte as RutDatos),
            rut,
        });
    };

    private readonly manejarCambioPasaporte = (pasaporte: string) => {
        this.realizarCambio({
            ...(this.props.rutPasaporte as PasaporteDatos),
            pasaporte,
        });
    };

    private readonly manejarCambioPais = (pais: string) => {
        this.realizarCambio({
            ...(this.props.rutPasaporte as PasaporteDatos),
            pais,
        });
    };

    private realizarCambio(nuevoState: Partial<RutPasaporteDatos>) {
        const { alCambiar } = this.props;

        if (alCambiar) {
            alCambiar({ ...this.props.rutPasaporte, ...(nuevoState as {}) });
        }
    }
}

export interface RutPasaporteProps {
    /** Valor que usará el campo. Requerido. */
    rutPasaporte: RutPasaporteDatos;

    /** Determina si el campo es requerido. Por defecto false. */
    requerido?: boolean;

    /** Etiqueta que tendrá el <Form.Field>. Por defecto 'Rut/Pasaporte'. */
    label?: string;

    /** Ancho del <Form.Field> en columnas de semantic-ui. */
    width?: SemanticWIDTHS;

    /** Función que será llamada cuando ocurra un cambio en el componente. Requerido. */
    alCambiar(rutPasaporte: RutPasaporteDatos): void;
}

export const RutPasaporte: React.FunctionComponent<RutPasaporteProps> = props => {
    const { label = 'Rut/Pasaporte', width, ...resto } = props;

    let error = false;
    if (props.rutPasaporte) {
        const { rutPasaporte } = props;
        if (rutPasaporte && rutPasaporte.tipo === 'rut' && rutPasaporte.rut.length > 1) {
            error = !rutUtils.esValido(rutPasaporte.rut);
        }
    }

    return (
        <Form.Field required={props.requerido} width={width} error={error}>
            <label>{label}</label>
            <RutPasaporteInput error={error} {...resto} />
        </Form.Field>
    );
};

export default RutPasaporte;



// WEBPACK FOOTER //
// ./src/modulos/Matriculas/IngresoNuevaMatricula/componentes/RutPasaporte/index.tsx